import React,{useEffect,useState} from 'react';
import queryString from 'query-string';
import TopTitleTwo from './TopTitleTwo';
import Pagination from "react-js-pagination";
import {instance} from './common';
import Bottom_menu from './Bottom_menu';

function Quality({history,location}){
    
    const query = queryString.parse(location.search);
    const {jae_id} = query;

    const [data, setData] = useState([]);
    const ppp = 10;
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const [product, setProdoct] = useState('');
    const parsedsigong = JSON.parse(window.sessionStorage.result);
    const {u_id} = parsedsigong;

    let obj = {
        page: page,
        ppp: ppp,
        jae_id:jae_id,
    }


    useEffect(() => {

        const fetchData = async () => {
            instance.post('/jaego/id', obj).then(function (res) {
                setData(res.data.rows);
                setProdoct(res.data.rows[0].pr_name)
                setTotal(res.data.totalCount);
            });

        };
        fetchData();
    }, [page, ppp]);

    const pageChange = (pageNumber) => {
        setPage(pageNumber);
      }


    console.log('data : ', data)
    return (
        <>
            <div className="container">
                <TopTitleTwo title1={product} title2="보증서 발행 관리"/>

                <table className="quality-table table table-bordered text-center">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>상품명</th>
                            <th>보증서 발행 제한</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map( (v,i) => 
                                <tr key={v.jae_id}>
                                    <td>{i+1}</td>
                                    <td>{v.pr_name}</td>
                                    <td>{v.pr_count*v.pr_limit}({v.pr_count*v.data_limit})</td>
                                </tr>
                            )
                        }
                    </tbody>
                    <tfoot></tfoot>
                </table>
                <div className="text-center">
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={10}
                        totalItemsCount={total}
                        pageRangeDisplayed={10}
                        onChange={pageChange}
                    />
                </div>
            </div>
            <Bottom_menu />
            
        </>
    )
}

export default Quality;